(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3887],{

/***/ 26460:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/jan-components/Section12",
      function () {
        return __webpack_require__(1172);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Section12; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);



function Section12() {
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: " mobile:py-[60px] z-0 flex w-full flex-col items-center justify-center py-[120px]",
        style: {
            backgroundColor: "rgba(249, 250, 251, 1)"
        },
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("picture", {
                className: "z-20",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                        media: "(max-width: 800px)",
                        srcSet: "/event/jan/01_event02_contents06_img_mo-min.png"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                        media: "(min-width: 800px)",
                        srcSet: "/event/jan/01_event02_contents06_img_pc-min.png"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                        alt: "alt text here",
                        className: " mobile:max-w-[328px] mobile:w-[328px] mobile:h-[2900px] h-[2138px] w-[878px] max-w-[878px]"
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "mobile:h-[60px] h-[80px]"
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("picture", {
                className: "z-20",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                        media: "(max-width: 800px)",
                        srcSet: "/event/jan/01_event02_contents06_bt_mo-min.png"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                        media: "(min-width: 800px)",
                        srcSet: "/event/jan/01_event02_contents06_bt_pc-min.png"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                        alt: "alt text here",
                        className: " mobile:max-w-[343px] mobile:w-[343px] mobile:h-[410px] h-[350px] w-[960px] max-w-[960px]"
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                onClick: function onClick() {
                    window.open("/pricing");
                },
                className: "mobile:w-[300px] mobile:mt-[-100px] mobile:text-[17px] mobile:leading[24px] mobile:font-[700] mobile:p-[16px] z-30 mt-[-160px] w-[237px] p-[10px] text-[24px] font-[800] leading-[36px]",
                style: {
                    height: "56px",
                    backgroundColor: "rgba(44, 209, 103, 1)",
                    color: "rgba(255, 255, 255, 1)",
                    textAlign: "center",
                    borderRadius: "12px",
                    cursor: "pointer"
                },
                children: "구매하기 >"
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(26460); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);